import { FETCH_MEMBERS, FETCH_MEMBERS_SUCCESS, FETCH_MEMBERS_FAILURE, SAVE_MEMBERS_SUCCESS,
  SAVE_MEMBERS_FAILURE, DELETE_MEMBERS_SUCCESS, DELETE_MEMBERS_FAILURE, MEMBERS_AJAX_CALL,
  MEMBERS_CLEAR_AJAX_CALL, MEMBERS_START_UPLOAD, MEMBERS_STOP_UPLOAD, SET_LAST_PAID, EXPORT_MEMBERS,
  EXPORT_MEMBERS_SUCCESS, EXPORT_MEMBERS_FAILURE } from '../actions/Members'

import { URIS } from '../Uris'

const initialState = {
  list: null,
  error: null,
  loading: false,
  ajaxSpinner: false,
  ajaxStatus: null,
  uploading: false
}

export default function members (state = initialState, action) {
  switch (action.type) {
    case FETCH_MEMBERS:
      return {...state, loading: true, error: null, list: null}
    case FETCH_MEMBERS_SUCCESS:
      return {...state, list: action.payload, loading: false, error: null}
    case FETCH_MEMBERS_FAILURE:
      return {...state, error: action.payload, loading: false, list: null}
    case SAVE_MEMBERS_SUCCESS:
      return {...state,
        list: ((state.list.findIndex(x => x.id === action.payload.id) === -1)
          ? state.list.concat(action.payload)
          : state.list.map((item) => {
            return (item.id === action.payload.id) ? action.payload : item
          })),
        ajaxStatus: null,
        ajaxSpinner: false}
    case SAVE_MEMBERS_FAILURE:
      return {...state, ajaxStatus: action.payload, ajaxSpinner: false}
    case DELETE_MEMBERS_SUCCESS:
      return {...state,
        list: state.list.filter((item) => {
          return item.id !== action.payload
        }),
        ajaxStatus: null,
        ajaxSpinner: false}
    case DELETE_MEMBERS_FAILURE:
      return {...state, ajaxStatus: action.payload, ajaxSpinner: false}
    case MEMBERS_AJAX_CALL:
      return { ...state, ajaxSpinner: true, ajaxStatus: null }
    case MEMBERS_CLEAR_AJAX_CALL:
      return { ...state, ajaxSpinner: false, ajaxStatus: null }
    case MEMBERS_START_UPLOAD:
      return { ...state, uploading: true }
    case MEMBERS_STOP_UPLOAD:
      return { ...state, uploading: false }
    case SET_LAST_PAID:
      return {...state,
        list: state.list.map((item) => {
          return (item.id === action.payload.id) ? { ...item, last_paid: action.payload.last_paid } : item
        })
      }
    case EXPORT_MEMBERS:
      return { ...state, ajaxSpinner: true }
    case EXPORT_MEMBERS_SUCCESS:
      window.open(URIS.apiBase + action.payload.data, '_blank')
      return { ...state,
        ajaxSpinner: false
      }
    case EXPORT_MEMBERS_FAILURE:
      return { ...state, ajaxSpinner: false, error: action.payload }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/members.js